import React, { Component } from "react";
import { AppContext } from "../context/AppContext";
import LoginContainer from '../components/LoginContainer';
import { Redirect } from 'react-router-dom';
import isPage from '../hoc/isPage';
//import config from '../config/config';
//import { isSocialLogin, isEmpty } from '../helpers';

class Callback extends Component {

    state = {
        isLoadingUserData: false,
        isAuthenticating: true,
        error: false
    }
    componentDidMount() {
        // handle the authentication result
        this.context.auth.handleAuthentication().then(() => {
            this.setState({
                isAuthenticating: false,
                isLoadingUserData: true
            });
        }).catch(e => {
            this.setState({
                isAuthenticating: false,
                error: true
            });
        });
    }

    onDataLoaded = () => {
        this.setState({
            isLoadingUserData: false,
            error: false
        })
    }
    onFail = () => {
        this.setState({
            isLoadingUserData: false,
            error: true
        })
    }
    render() {

        // handle auth result
        // if good, then 
        //      load up the login data
        //      if good, then
        //             redirect to dashboard
        //      else
        //             redirect to login screen
        // else 
        //      redirect to login screen

        if (this.state.isAuthenticating) {
            return (<React.Fragment />);

        } else if (this.state.error) { // done authenticating, but there was an error
            return (<Redirect to="/?s=unableToLogin" />);

        } else { // done authenticating, and there were no errors

            if (this.state.isLoadingUserData) { // we need to load user data
                return <LoginContainer />

            } else {
                return <React.Fragment />
            }


        }



    }
}

export default isPage(Callback);
Callback.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/Callback.js